import { $axios } from '@/shared/api/axios'
import { API_URL } from '@/shared/lib/const/env'
import { ServerResponse } from '@/shared/types/common'

export const refreshAuthTokens = async () => {
	const { data } = await $axios.post<ServerResponse<{ ACCESS_TOKEN: string }>>(`${API_URL}/auth/refresh_token`)

	return data
}
